export const getAgencyRecommendationsUrl = () => 'agency/recommendations';
